import Vue from 'vue';
import moment from 'moment';
import vuetify from '@/plugins/vuetify';
import '@/plugins/vue-frag';
import DefaultLayout from '@/layout/DefaultLayout.vue';
import store from '@/store';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
Vue.prototype.$assetEndpoint = process.env.VUE_APP_ASSET_ENDPOINT;

Vue.component('default-layout', DefaultLayout);

Vue.filter('translateStatus', (value: string) => {
  if (value === 'APPROVED') return 'ดำเนินการแล้ว';
  if (value === 'PENDING') return 'รอการดำเนินการ';
  if (value === 'REJECTED') return 'ปฏิเสธการดำเนินการ';
  if (value === 'IN_PROGRESS') return 'กำลังดำเนินการ';
  return value;
});

Vue.filter('formatDate', (value: string|number) => moment(value).format('YYYY-MM-DD HH:mm:ss'));

store.dispatch('Auth/autoLogin').then(async () => {
  await store.dispatch('BankConfig/fetchConfig');
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app');
});
